import { render, staticRenderFns } from "./DialogPart.vue?vue&type=template&id=45c99140&"
import script from "./DialogPart.vue?vue&type=script&lang=js&"
export * from "./DialogPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports